import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTags } from "../../features/tags/tagsSlice";
import { filterReleased } from "../../features/filter/filterSlice";
import Tag from "./Tag";

export default function Tags() {
  const { tags } = useSelector((state) => state.tags);
  const dispatch = useDispatch();
  const {
    tags: selectedTags,
    search,
    author: slectedAuthor,
  } = useSelector((state) => state.filter);

  let filterApplied = selectedTags.length > 0 || search || slectedAuthor;

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  return tags?.length > 0 ? (
    <section className="w-full flex items-center justify-around   border-b px-5">
      <div className=" mx-auto px-5 py-6 lg:px-0 flex gap-2 self-start  overflow-y-auto">
        {tags.map((tag) => (
          <Tag key={tag.id} title={tag.title} />
        ))}
      </div>
      {filterApplied && (
        <div onClick={() => dispatch(filterReleased())}>
          <p className="bg-red-400/50 border border-red-400 text-red-900  px-4 py-1 rounded-full cursor-pointer">
            {" "}
            Release Filter
          </p>
        </div>
      )}
    </section>
  ) : null;
}
